import { useaxios } from "../../../utils/useaxios";
export default (company_id, company_return_date, company_return_note, user_id, items) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    initDispatch({ type: 'loadingTrue' });
    useaxios('return_item_company/create.php', { company_id, company_return_date, company_return_note, user_id, items }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        }
        if (res.status == "ok") {
            setrecaller(recaller + 1);
        } else {
            initDispatch({ type: 'loadingFalse' });
            alert('بڕی دیاریکراو لەم کاڵایە نییە ');
        }
        // setloading(false);
    });
}